type GetInvoiceDueDateLabelArgs = {
  dueDate?: string;
  invoiceDate?: string;
};

const toValueOrUndefined = (s?: string) => (s && s.trim() ? s.trim() : undefined);

export const getInvoiceDueDateLabel = ({ dueDate, invoiceDate }: GetInvoiceDueDateLabelArgs) => {
  const normalizedDueDate = toValueOrUndefined(dueDate);
  const normalizedInvoiceDate = toValueOrUndefined(invoiceDate);

  return normalizedDueDate ?? normalizedInvoiceDate ?? 'Unknown';
};
